import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './workspace.css';
import App from './App';
import './styles/reference-ui.css';
import reportWebVitals from './reportWebVitals';

// Browser extensions occasionally inject scripts that throw inside the page.
// Keep those third-party errors out of Create React App's development overlay;
// application errors continue to surface normally.
if (process.env.NODE_ENV === 'development') {
  const isBrowserExtensionError = (value = '') => {
    const text = String(value);
    return text.includes('chrome-extension://') || text.includes('moz-extension://');
  };

  window.addEventListener('error', (event) => {
    const extensionError = isBrowserExtensionError(event.filename)
      || isBrowserExtensionError(event.error?.stack)
      || (String(event.message).includes("reading 'M_ID'") && isBrowserExtensionError(event.error?.stack));
    if (extensionError) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    if (isBrowserExtensionError(event.reason?.stack || event.reason)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
